"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startObserver = startObserver;
exports.stopObserver = stopObserver;
var observer;

function startObserver(observeCallback) {
  var target = document.getElementById('__next');
  var config = {
    childList: true,
    subtree: true
  };
  observer = new MutationObserver(observeCallback);
  observer.observe(target, config);
}

function stopObserver() {
  if (observer && observer instanceof MutationObserver) {
    observer.disconnect();
    observer = null;
  }
}